import { PlayCircle } from 'react-feather'
import { Typography } from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

export const StartActionButtonIcon = styled(PlayCircle)`
    color: ${theme.colors.white};
`

export const StartActionButtonLabel = styled(Typography)``

export const VerifyButton = styled(ButtonMui)`
    background: ${theme.colors.green2} !important;
`

export const ContainerButtons = styled.div`
    display: flex;
    gap: 16px;
`

export const Invoices = styled.div`
    display: flex;
    justify-content: center;
`

export const Container = styled.div`
  min-height: 5rem;
  max-height: 10rem;
  overflow-y: scroll;
  scroll-behavior: smooth;
`
